import { Box, Button, Divider, Stack } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { MathJax } from 'better-react-mathjax';
import { memo } from 'react';

const ChapterSummerizeItem = ({ original_text, summery_text, onDelete, _id }) => {
  return (
    <Stack>
      <Stack direction="row-reverse" sx={{ my: '0.5rem' }}>
        <Button onClick={() => onDelete(_id)} variant="contained" color="error">
          Delete
        </Button>
      </Stack>
      <Accordion
        defaultExpanded
        sx={{
          bgcolor: 'rgba(0, 0, 0, 0.02)',
        }}
        disableGutters
      >
        <AccordionSummary sx={{ color: '#0044aa', fontWeight: 'bold' }}>Summary Text</AccordionSummary>
        <AccordionDetails sx={{ color: '#0044aa' }}>
          <MathJax hideUntilTypeset="every" dynamic>
            <Box dangerouslySetInnerHTML={{ __html: summery_text }} />
          </MathJax>
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          bgcolor: 'rgba(0, 0, 0, 0.04)',
        }}
        disableGutters
      >
        <AccordionSummary sx={{ fontWeight: 'bold' }}>Orginal Text</AccordionSummary>
        <AccordionDetails>
          <MathJax hideUntilTypeset="every" dynamic>
            <Box dangerouslySetInnerHTML={{ __html: original_text }} />
          </MathJax>
        </AccordionDetails>
      </Accordion>

      <Divider color="grey" sx={{ height: '5px', my: '1rem', borderRadius: '10px' }} />
    </Stack>
  );
};

export default memo(ChapterSummerizeItem);
